/* @flow */

import React from 'react';
import { Provider } from 'react-redux';
import App from '../pages/App';

type Props = {
  store: Object,
  history: Object,
};

export default class Root extends React.Component<Props> {
  props: Props;

  render() {
    const { store, history } = this.props;

    return (
      <Provider store={store}>
        <App history={history} />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/containers/Root.js